import React from "react";
import "./Link.css";

const NotFound = () => {
  return (
    <div className="links">
      <div className="container">
        <div className="column">
          <img src="../error-page-not-found-vector-27898543.jpg" alt="sdf" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
